export const datePickerPopupSlotProps = {
    previousIconButton: { sx: { color: '#3498db', '&:hover': { backgroundColor: 'rgba(52,152,219,0.08)' } } },
    nextIconButton: { sx: { color: '#3498db', '&:hover': { backgroundColor: 'rgba(52,152,219,0.08)' } } },
    switchViewButton: { sx: { color: '#1e293b' } },
    day: {
        sx: {
            borderRadius: '8px',
            fontWeight: 500,
            '&.Mui-selected': {
                backgroundColor: '#3498db !important',
                color: '#fff',
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(52,152,219,0.35)'
            },
            '&.Mui-selected:hover': { backgroundColor: '#2980b9 !important' },
            '&.Mui-selected:focus': { backgroundColor: '#3498db !important' },
            '&:hover': { backgroundColor: 'rgba(52,152,219,0.1)' },
            '&.MuiPickersDay-today:not(.Mui-selected)': {
                border: '2px solid #3498db',
                color: '#3498db'
            }
        }
    },
    desktopPaper: {
        sx: {
            direction: 'ltr',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(52, 152, 219, 0.18)',
            border: '1px solid #e3f2fd',
            overflow: 'hidden',
            '& .MuiPickersCalendarHeader-root': {
                backgroundColor: '#f8fafb',
                borderBottom: '1px solid #e3f2fd',
                paddingTop: '12px',
                paddingBottom: '8px',
            },
            '& .MuiPickersCalendarHeader-label': {
                fontWeight: 700,
                color: '#1e293b',
                fontSize: '0.95rem'
            },
            '& .MuiDayCalendar-weekDayLabel': {
                color: '#64748b',
                fontWeight: 600,
                fontSize: '0.8rem'
            }
        }
    }
};

export const styles = {
    pageContainer: {
        padding: { xs: '16px', sm: '24px', md: '32px' },
        backgroundColor: '#fafafa',
        backgroundImage: `
            radial-gradient(circle at 1px 1px, rgba(0, 0, 0, 0.02) 1px, transparent 0)
        `,
        backgroundSize: '40px 40px',
        minHeight: '100%',
        flex: 1,
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        padding: '40px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        margin: '0 auto',
        maxWidth: '600px',
        border: '1px solid #e8edf2'
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        gap: '24px'
    },
    headerContainer: {
        marginBottom: { xs: '16px', sm: '24px', md: '32px' },
        backgroundColor: '#ffffff',
        backgroundImage: `
            linear-gradient(90deg, rgba(52, 152, 219, 0.03) 1px, transparent 1px),
            linear-gradient(rgba(52, 152, 219, 0.03) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
        borderRadius: { xs: '8px', md: '12px' },
        padding: { xs: '20px 16px', sm: '24px 20px', md: '32px 36px' },
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e8edf2'
    },
    searchBarContainer: {
        marginBottom: '0'
    },
    tabsContainer: {
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        marginBottom: '32px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        padding: '0 20px',
        border: '1px solid #e8edf2'
    },
    tableContainer: {
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        border: '1px solid #e8edf2'
    },
    statusChip: {
        fontWeight: 600,
        borderRadius: '20px',
        padding: '5px 16px',
        fontSize: '0.85rem',
        letterSpacing: '0.3px'
    },
    statusPending: {
        backgroundColor: '#fff8e1',
        color: '#f57c00',
        border: '1px solid #ffe0b2'
    },
    statusApproved: {
        backgroundColor: '#e8f5e9',
        color: '#388e3c',
        border: '1px solid #c8e6c9'
    },
    statusRejected: {
        backgroundColor: '#ffebee',
        color: '#d32f2f',
        border: '1px solid #ffcdd2'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '300px', sm: '360px', md: '420px' },
        gap: { xs: '16px', sm: '20px', md: '24px' },
        color: '#64748b',
        backgroundColor: '#ffffff',
        backgroundImage: `
            radial-gradient(circle at 2px 2px, rgba(100, 116, 139, 0.04) 1px, transparent 0)
        `,
        backgroundSize: '32px 32px',
        borderRadius: { xs: '8px', md: '12px' },
        padding: { xs: '24px 16px', sm: '32px 24px', md: '40px' }
    },
    formContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
        padding: { xs: '0 8px', sm: '0 12px', md: '0 16px' }
    },
    formPaper: {
        borderRadius: { xs: '8px', md: '12px' },
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        border: '1px solid #e8edf2'
    },
    formHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: { xs: '16px 12px', sm: '20px 24px', md: '28px 36px' },
        backgroundColor: '#2c3e50',
        backgroundImage: `
            linear-gradient(135deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(225deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(315deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%)
        `,
        backgroundSize: '40px 40px',
        backgroundPosition: '0 0, 20px 0, 20px -20px, 0px 20px',
        color: '#ffffff',
        borderBottom: '3px solid #3498db'
    },
    formActions: {
        display: 'flex',
        justifyContent: 'center',
        gap: '14px',
        marginTop: '36px',
        paddingTop: '36px',
        borderTop: '1px solid #e8edf2'
    },
    cardContainer: {
        backgroundColor: '#ffffff',
        backgroundImage: `
            linear-gradient(90deg, rgba(52, 152, 219, 0.02) 1px, transparent 1px),
            linear-gradient(rgba(52, 152, 219, 0.02) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
        borderRadius: { xs: '8px', md: '12px' },
        padding: { xs: '18px', sm: '22px', md: '26px' },
        marginBottom: { xs: '14px', sm: '16px', md: '18px' },
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e8edf2',
        transition: 'all 0.25s ease',
        '&:hover': {
            boxShadow: '0 6px 20px rgba(52, 152, 219, 0.12)',
            borderColor: '#3498db',
            transform: 'translateY(-2px)'
        }
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '18px',
        paddingBottom: '18px',
        borderBottom: '2px solid #f1f5f9'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        marginBottom: '18px'
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        paddingTop: '18px',
        borderTop: '1px solid #f1f5f9'
    },
    fieldRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '6px 0'
    },
    fieldLabel: {
        fontWeight: 600,
        color: '#475569',
        minWidth: '130px',
        fontSize: '0.9rem'
    },
    fieldValue: {
        color: '#1e293b',
        fontSize: '0.95rem',
        fontWeight: 500
    },
    dialogContent: {
        padding: '28px',
        minWidth: '420px',
        backgroundColor: '#fafafa'
    },
    dialogActions: {
        padding: '18px 28px',
        borderTop: '1px solid #e8edf2',
        backgroundColor: '#ffffff'
    },
    actionsContainer: {
        marginBottom: '28px',
        padding: '22px 28px',
        background: '#ffffff',
        backgroundImage: `
            linear-gradient(90deg, rgba(52, 152, 219, 0.02) 1px, transparent 1px),
            linear-gradient(rgba(52, 152, 219, 0.02) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
        borderRadius: '12px',
        border: '1px solid #e8edf2',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '18px'
    },
    actionsChip: {
        background: '#2c3e50',
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '0.9rem',
        height: '34px',
        padding: '0 18px',
        borderRadius: '18px'
    },
    approveButton: {
        background: '#27ae60',
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '10px',
        padding: '11px 28px',
        letterSpacing: '0.3px',
        boxShadow: '0 2px 6px rgba(39, 174, 96, 0.2)',
        '&:hover': {
            background: '#229954',
            boxShadow: '0 4px 12px rgba(39, 174, 96, 0.3)',
            transform: 'translateY(-1px)'
        },
        '&:disabled': {
            background: '#cbd5e0',
            boxShadow: 'none'
        }
    },
    rejectButton: {
        background: '#e74c3c',
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '10px',
        padding: '11px 28px',
        letterSpacing: '0.3px',
        boxShadow: '0 2px 6px rgba(231, 76, 60, 0.2)',
        '&:hover': {
            background: '#c0392b',
            boxShadow: '0 4px 12px rgba(231, 76, 60, 0.3)',
            transform: 'translateY(-1px)'
        },
        '&:disabled': {
            background: '#cbd5e0',
            boxShadow: 'none'
        }
    },
    clearButton: {
        borderRadius: '10px',
        padding: '11px 28px',
        fontWeight: 600,
        textTransform: 'none',
        borderWidth: '1px',
        color: '#475569',
        borderColor: '#cbd5e0',
        backgroundColor: '#ffffff',
        letterSpacing: '0.3px',
        '&:hover': {
            borderWidth: '1px',
            borderColor: '#94a3b8',
            backgroundColor: '#f8fafc',
            transform: 'translateY(-1px)'
        }
    },
    headerContentWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: { xs: '12px', sm: '16px', md: '22px' }
    },
    headerIconBox: {
        width: { xs: '48px', sm: '56px', md: '62px' },
        height: { xs: '48px', sm: '56px', md: '62px' },
        borderRadius: { xs: '10px', md: '14px' },
        backgroundColor: '#2c3e50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(44, 62, 80, 0.2)',
        border: '2px solid #34495e'
    },
    headerTitle: {
        fontWeight: 700,
        color: '#1e293b',
        letterSpacing: '-0.3px',
        fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.125rem' }
    },
    headerSubtitle: {
        color: '#64748b',
        fontWeight: 500,
        marginTop: '6px',
        fontSize: { xs: '0.875rem', sm: '0.95rem', md: '1rem' }
    },
    primaryButton: {
        backgroundColor: '#3498db',
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(52, 152, 219, 0.25)',
        letterSpacing: '0.3px',
        '&:hover': {
            backgroundColor: '#2980b9',
            boxShadow: '0 4px 14px rgba(52, 152, 219, 0.35)',
        },
        '&:disabled': { backgroundColor: '#cfd8dc', boxShadow: 'none' }
    },
    cancelButton: {
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '8px',
        color: '#475569',
        borderColor: '#cbd5e0',
        backgroundColor: '#ffffff',
        letterSpacing: '0.3px',
        '&:hover': {
            borderColor: '#94a3b8',
            backgroundColor: '#f8fafc',
        }
    },
    newReportButton: {
        backgroundColor: '#3498db',
        fontSize: { xs: '13px', sm: '14px', md: '15px' },
        padding: { xs: '10px 20px', sm: '11px 26px', md: '12px 30px' },
        fontWeight: 600,
        borderRadius: { xs: '8px', md: '10px' },
        boxShadow: '0 2px 8px rgba(52, 152, 219, 0.25)',
        textTransform: 'none',
        letterSpacing: '0.3px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#2980b9',
            boxShadow: '0 4px 14px rgba(52, 152, 219, 0.35)',
            transform: 'translateY(-2px)'
        },
        '&:active': {
            transform: 'translateY(0)'
        }
    },
    tableWrapper: {
        padding: '18px 0'
    },
    emptyStateIcon: {
        width: { xs: '72px', sm: '84px', md: '96px' },
        height: { xs: '72px', sm: '84px', md: '96px' },
        borderRadius: '50%',
        background: '#f1f5f9',
        backgroundImage: `
            radial-gradient(circle at 2px 2px, rgba(100, 116, 139, 0.1) 1px, transparent 0)
        `,
        backgroundSize: '16px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: { xs: '12px', sm: '16px', md: '18px' },
        border: '3px solid #e2e8f0'
    },
    emptyStateTitle: {
        fontWeight: 700,
        color: '#475569',
        marginBottom: '10px',
        fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' }
    },
    emptyStateText: {
        color: '#64748b',
        textAlign: 'center',
        maxWidth: '420px',
        lineHeight: '1.7',
        fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem' }
    },
    recordsHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        marginBottom: '28px',
        padding: '20px 28px',
        background: '#2c3e50',
        backgroundImage: `
            linear-gradient(135deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(225deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
            linear-gradient(315deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%)
        `,
        backgroundSize: '40px 40px',
        backgroundPosition: '0 0, 20px 0, 20px -20px, 0px 20px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(44, 62, 80, 0.2)',
        border: '2px solid #34495e'
    },
    recordsHeaderTitle: {
        color: '#ffffff',
        fontWeight: 700,
        flex: 1,
        letterSpacing: '0.3px',
        fontSize: '1.2rem'
    },
    recordsCountBadge: {
        backgroundColor: '#ffffff',
        color: '#2c3e50',
        fontWeight: 700,
        padding: '7px 18px',
        borderRadius: '20px',
        fontSize: '0.95rem',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)'
    },
    recordsGrid: {
        display: 'grid',
        gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(auto-fill, minmax(350px, 1fr))',
            md: 'repeat(auto-fill, minmax(410px, 1fr))'
        },
        gap: { xs: '16px', sm: '18px', md: '22px' }
    },
    reportsTableContainer: {
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e8edf2',
        overflowX: 'auto'
    },
    reportsTableHeaderRow: {
        backgroundColor: '#f8fafc',
        backgroundImage: `
            linear-gradient(90deg, rgba(52, 152, 219, 0.03) 1px, transparent 1px),
            linear-gradient(rgba(52, 152, 219, 0.03) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px'
    },
    reportsTableHeaderCell: {
        fontWeight: 700,
        color: '#334155',
        fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.9rem' },
        padding: { xs: '12px 8px', sm: '16px 12px', md: '18px' },
        borderBottom: '2px solid #e2e8f0',
        letterSpacing: '0.3px',
        whiteSpace: 'nowrap'
    },
    reportsTableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff'
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#fafafa'
        },
        '&:hover': {
            backgroundColor: '#f0f9ff',
            borderLeft: '3px solid #3498db'
        },
        transition: 'all 0.2s ease',
        cursor: 'pointer'
    },
    reportsTableCellId: {
        fontWeight: 700,
        color: '#2563eb',
        fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
        padding: { xs: '12px 8px', sm: '14px 12px', md: '16px' },
        letterSpacing: '0.2px'
    },
    reportsTableCellDefault: {
        color: '#64748b',
        fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.875rem' },
        padding: { xs: '12px 8px', sm: '14px 12px', md: '16px' }
    },
    reportsTableCellBold: {
        color: '#334155',
        fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.875rem' },
        padding: { xs: '12px 8px', sm: '14px 12px', md: '16px' },
        fontWeight: 600
    },
    reportsTableCellPadding: {
        padding: { xs: '12px 8px', sm: '14px 12px', md: '16px' }
    },
    reportsCountChip: {
        backgroundColor: '#2c3e50',
        color: '#ffffff',
        fontWeight: 700,
        minWidth: '52px'
    },
    reportsViewButton: {
        backgroundColor: '#3498db',
        color: '#ffffff',
        fontWeight: 600,
        boxShadow: '0 2px 6px rgba(52, 152, 219, 0.2)',
        '&:hover': {
            backgroundColor: '#2980b9',
            boxShadow: '0 4px 10px rgba(52, 152, 219, 0.3)',
            transform: 'translateY(-1px)'
        }
    },
    settingsPaper: {
        background: '#ffffff',
        border: '1px solid #e8edf2',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)'
    },
    settingsContainer: {
        padding: '52px 36px',
        textAlign: 'center',
        backgroundImage: `
            radial-gradient(circle at 2px 2px, rgba(52, 152, 219, 0.04) 1px, transparent 0)
        `,
        backgroundSize: '40px 40px'
    },
    settingsIcon: {
        width: '84px',
        height: '84px',
        borderRadius: '50%',
        background: '#2c3e50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 28px',
        boxShadow: '0 6px 20px rgba(44, 62, 80, 0.25)',
        border: '3px solid #34495e'
    },
    settingsTitle: {
        marginBottom: '14px',
        fontWeight: 700,
        color: '#1e293b',
        fontSize: '1.8rem'
    },
    settingsDescription: {
        color: '#64748b',
        maxWidth: '520px',
        margin: '0 auto',
        lineHeight: '1.7',
        fontSize: '1.05rem'
    },
    settingsPlaceholder: {
        marginTop: '36px',
        padding: '28px',
        background: '#f8fafc',
        backgroundImage: `
            linear-gradient(90deg, rgba(52, 152, 219, 0.03) 1px, transparent 1px),
            linear-gradient(rgba(52, 152, 219, 0.03) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
    },
    settingsPlaceholderText: {
        color: '#475569',
        fontWeight: 600,
        fontSize: '1.05rem'
    },
    tableHeaderCell: {
        fontWeight: 700,
        color: '#334155',
        fontSize: '0.75rem',
        padding: '8px 6px',
        whiteSpace: 'nowrap',
        borderBottom: '2px solid #e2e8f0',
        textAlign: 'center'
    },
    tableCell: {
        fontSize: '0.8rem',
        padding: '6px 6px',
        color: '#334155',
    },
    tableDateField: {
        width: '155px',
        '& .MuiInputBase-input': {
            fontSize: '0.75rem',
            padding: '4px 6px',
        },
        '& .MuiInputAdornment-root': {
            marginLeft: '0px',
        },
        '& .MuiInputAdornment-root .MuiIconButton-root': {
            color: '#3498db',
            padding: '4px',
            '&:hover': { backgroundColor: 'rgba(52, 152, 219, 0.08)' }
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db', borderWidth: '2px' }
        }
    },
    datePickerField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db', borderWidth: '2px' }
        },
        '& .MuiInputLabel-root.Mui-focused': { color: '#3498db' },
        '& .MuiInputAdornment-root .MuiIconButton-root': {
            color: '#3498db',
            '&:hover': { backgroundColor: 'rgba(52, 152, 219, 0.08)' }
        }
    },
    formTextField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3498db', borderWidth: '2px' }
        },
        '& .MuiInputLabel-root.Mui-focused': { color: '#3498db' },
        '& .MuiInputAdornment-root .MuiIconButton-root': {
            color: '#3498db',
            '&:hover': { backgroundColor: 'rgba(52, 152, 219, 0.08)' }
        }
    },
    formTextFieldReadOnly: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#f8fafb',
        }
    }
};
